import React, { useState } from "react";
import BMInput from "../comps/BMInput";
import { Divider, Space, Tooltip } from "antd";
import { tt_toi_bg_margin_b, tt_toi_bg_margin_l, tt_toi_bg_margin_r, tt_toi_bg_margin_t } from "../../utils/Utils";

export default function PaddingUI(props) {

    const { value = {}, onChange = () => { }, label = "MARGIN" } = props;
    const { t = 0, r = 0, b = 0, l = 0} = value;

  
    const save = (_key, _value) => {
        onChange({...value, [_key] : _value});
    }

    return (
        <div>
            <Space>
                <BMInput width={"40px"} value={t} onChange={(_v) => save("t", _v )} number min={0} max={1000} prefix={<Tooltip placement="left" title={tt_toi_bg_margin_t}>T</Tooltip>} />
                <BMInput width={"40px"} value={r} onChange={(_v) => save("r", _v )} number min={0} max={1000} prefix={<Tooltip placement="left" title={tt_toi_bg_margin_r}>R</Tooltip>} />
                <BMInput width={"40px"} value={b} onChange={(_v) => save("b", _v )} number min={0} max={1000} prefix={<Tooltip placement="left" title={tt_toi_bg_margin_b}>B</Tooltip>} />
                <BMInput width={"40px"} value={l} onChange={(_v) => save("l", _v )} number min={0} max={1000} prefix={<Tooltip placement="left" title={tt_toi_bg_margin_l}>L</Tooltip>} />
            </Space>
        </div>
    )
}